import { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import BreadCrumb from '../../../../component/BreadCrumb';
import TextEditor from '../../../../component/editor/TextEditor';
import InputBox from '../../../../component/InputBox';
import SelectionBox from '../../../../component/SelectionBox';
import AuthenticationUtil from '../../../../util/AuthenticationUtil';
import { usePrompt } from '../../../../util/PromptUtil';
import { CODE_GROUP_ID, COMMUNITY_QNA_PATH } from '../../../../constant/Constant';
import CodeUtil from '../../../../util/CodeUtil';
import BoardPupupCheck from '../../../../component/BoardPupupCheck';
import PopupRef from '../../../../component/PopupRef';
import { actionAdd } from '../../../../module/body/community/qna/CommunityQnaModule';
import { VIEW_COMMUNITY_QNA_ADD } from '../../../../constant/ViewConstant';
import CancelButtonBox from '../../../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../../../component/buttons/ConfirmButtonBox';
import MultiFileAttachBox from '../../../../component/MultiFileAttachBox';
import NullCheckUtil from '../../../../util/NullCheckUtil';

const CommunityQnaAddView = () => {
    // const auth = AuthenticationUtil.get();
    // usePrompt('현재 페이지를 벗어나시겠습니까?', true);

    const [postingNo, setPostingNo] = useState('');
    const [postingTitleNm, setPostingTitleNm] = useState('');
    const [postingCtnt, setPostingCtnt] = useState('');
    const [postingTypeCd, setPostingTypeCd] = useState('');
    const [answerStatusCd, setAnswerStatusCd] = useState('');
    const [answerUniversityCd, setAnswerUniversityCd] = useState('');
    const [userNm, setUserNm] = useState('');
    const [regDttm, setRegDttm] = useState('');
    const [files, setFiles] = useState([]);

    const navigate = useNavigate();
    const popupRef = useRef(null);
    const dispatch = useDispatch();

    useEffect(() => {
        window.scrollTo(0, 0);
        setAnswerStatusCd(CodeUtil.getCodes('ANSWER_STATUS')[0].cd);
        setAnswerUniversityCd(AuthenticationUtil.getUserUniversityCd);
        setPostingTypeCd(CodeUtil.getCodes('POSTING_TYPE')[0].cd);
    }, []);

    const handleCancel = () => {
        navigate(COMMUNITY_QNA_PATH);
    };

    const handleConfirm = () => {
        if (validateQuestion()) {
            dispatch(
                actionAdd({
                    params: {
                        postingTitleNm,
                        postingCtnt,
                        postingTypeCd,
                        answerStatusCd,
                        answerUniversityCd,
                        files,
                    },
                    callback: (pno) => {
                        popupRef.current.openInfo(
                            '게시물 번호 ' + pno + '이 등록되었습니다. 질의응답 목록으로 이동합니다.',
                            () => {
                                return function () {
                                    navigate(COMMUNITY_QNA_PATH);
                                };
                            },
                        );
                    },
                }),
            );
        }
    };

    const validateQuestion = () => {
        if (NullCheckUtil.isEmpty(postingTitleNm)) {
            popupRef.current.openAlert('제목을 입력해주세요.');
            return false;
        }
        if (NullCheckUtil.isEmpty(postingCtnt)) {
            popupRef.current.openAlert('내용을 입력해주세요.');
            return false;
        }
        return true;
    };

    const uploadFileHandler = (result) => {
        setFiles((arr) => [
            ...arr,
            { fileUid: result.fileUid, fileNm: result.fileNm, regDttm: result.regDttm, noticeTypeCd: 'QUESTION' },
        ]);
    };

    const fileDeleteHandler = (files) => {
        setFiles(files);
    };

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg04'>
                    {/* <h2 className='con-title'>질의응답</h2> */}
                    <h2 className='con-title'>{VIEW_COMMUNITY_QNA_ADD.title}</h2>
                    <p className='con-title-p'>{VIEW_COMMUNITY_QNA_ADD.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <div className='community-wrap'>
                    <h3 className='cmnty-title faq-tit ico-question'>질의 내용</h3>
                    <div className='cmnty-top-box'>
                        <div className='top-box-row full'>
                            <InputBox
                                title='제목'
                                placeholder='제목을 입력하세요.'
                                value={postingTitleNm}
                                onChange={(e) => setPostingTitleNm(e.target.value)}
                            />
                        </div>
                        <div className='top-box-row divide'>
                            <div className='form-box mr14'>
                                <SelectionBox
                                    title='문의담당 대학'
                                    value={answerUniversityCd}
                                    size='long'
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)}
                                    useAll={false}
                                    onChange={(e) => setAnswerUniversityCd(e.target.value)}
                                />
                            </div>
                            <div className='form-box form-box-checkbox'>
                                <BoardPupupCheck
                                    title='비밀글 여부'
                                    onChecked={(e) => {
                                        e.target.checked
                                            ? setPostingTypeCd('CONFIDENTIAL')
                                            : setPostingTypeCd('PUBLIC');
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <TextEditor className='cmnty-wrt-box' value={postingCtnt} onChange={setPostingCtnt} />
                    <MultiFileAttachBox
                        className='cmnty-file-box'
                        uploadFileHandler={(e) => uploadFileHandler(e)}
                        files={files}
                        editable={true}
                        erasable={true}
                        fileDeleteHandler={(e) => fileDeleteHandler(e)}
                    />
                    <div className='cmnty-btn-box btn-wrap'>
                        <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                        <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                    </div>
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default CommunityQnaAddView;
